<template>

  <div>
    <!-- 第三行数据 -->
    <top style="width: 100%;height: 21vh;float: left;margin-left: 0.5%;background-color: #043447f0;"></top>


    <bottomLeft style="width: 32%;height: 80vh;float: left;margin-top: 1vh;margin-left: 0.5%;background-color: #043447f0;"></bottomLeft>

<bottomCenter  style="width: 34.5%;height: 23vh;margin-left: 33%;bottom: 0px;position: absolute;background-color: #043447f0;"></bottomCenter>

<bottomRight style="width: 32%;height: 80vh;float: right;margin-top: 1vh;;margin-left: 1%;background-color: #043447f0;" /> 



    <div style="width: 100%; height: 100%; position: absolute;z-index: -1;">
      <!-- <el-amap vid="amapDemo" :zoom="zoom" :pitch="47" :show-building-block="true" :center="center"
        :events="mapEvents" :markers="markers" style="width: 100%; height: 100%; border-radius: 5px">
        <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :visible="marker.visible"
          :draggable="marker.draggable" @init="markerInit" @click="clickMarker">
          <div style="padding: 5px 10px;white-space: nowrap;background: #1a83ff;color: #fff;">
            {{ marker.name }}总交易额:
            <span style="color: red;"> {{ marker.amount }}万元</span>
          </div>
        </el-amap-marker>

        <el-amap-layer-district :visible="true" type="Province" adcode="411500" :depth="2" :styles="styles"></el-amap-layer-district>


      </el-amap> -->
      <MapContainer style="width: 100%;height: 100%;"></MapContainer>

    </div>




  </div>
</template>

<script>
// import centerLeft2 from "./show1/centerLeft2";
import bottomLeft from "./show1/bottomLeft";
import bottomRight from "./show1/bottomRight";
import bottomCenter from "./show1/bottomCenter";
import top from "./show1/top";
import MapContainer from "./show1/MapContainer";

export default {
  components: {
    bottomLeft,
    bottomRight,
    bottomCenter,
    top,
    MapContainer

  },
  data() {
    return {
      zoom: 9.1,
      unitCode: localStorage.getItem("unitCode"),
      showDatas: [],
      unitCodes: [],
      tradeData: {},
      markers: [],
      center: [121.422318, 31.303038],
      styles: {
        'fill': '#00baff',
        'province-stroke': 'cornflowerblue',
              'city-stroke': 'white', // 中国地级市边界
              'county-stroke': 'rgba(255,255,255,0.5)' // 中国区县边界
      },
      mapEvents: {
        init(map) {
          map.setMapStyle('amap://styles/blue');
          // const marker = new AMap.Marker({
          //   position: [114.091058, 32.148624]
          // });
          // map.add(marker);
          this.map = map;
        },

      },


    };
  },
  created() {

    if (this.unitCode == "411500000000") {
      this.center = [114.09748, 32.15301];
    }
    if (this.unitCode == "410825000000") {
      this.center = [113.085992, 34.946372];
    }
    if (this.unitCode == "410225000000") {
      this.center = [114.821348, 34.822211];
    }

    this.getData();


  },


  methods: {
    async getData() {
      if (this.unitCode.indexOf("00000000") != -1) {
        this.getCountys();
      }
      else {
        this.getTowns();
      }
      this.showData();

    },
    async getCountys() {
      this.selectUnitCode = this.unitCode;
      const action = "/web/unitCode/getXians/" + this.unitCode;
      const {
        data: res
      } = await this.$http.get(action);
      this.unitCodes = res.data;
    },
    async getTowns() {
      const action = "/web/unitCode/getXiangs/" + this.unitCode;;
      const {
        data: res
      } = await this.$http.get(action);
      this.unitCodes = res.data;
    },
    showData() {
      this.$http.get("/web/tradeData?unitCode=" + localStorage.getItem("unitCode"))
        .then((
          res) => {
          this.tradeData = res.data.data;
          this.transferData();
        });


    },
    transferData() {
      this.unitCodes.push({ name: localStorage.getItem("unitName"), "unitCode": localStorage.getItem("unitCode"), location: localStorage.getItem("location") });


      for (var i = 0; i < this.unitCodes.length; i++) {
        for (var j = 0; j < this.tradeData.tradeAmtList.length; j++) {
          if (this.unitCodes[i].name == this.tradeData.tradeAmtList[j].unitName) {
            this.markers.push({
              position: [this.unitCodes[i].location.split(',')[0], this.unitCodes[i].location.split(',')[1]],
              name: this.unitCodes[i].name,
              amount: this.tradeData.tradeAmtList[j].amount / 10000,
              visible: true,
              draggable: false
            });
            continue;
          }
        }
      }
      console.log(this.markers)

      if (this.markers.length > 0)
        this.center = this.markers[0].position;
    },
    markerInit(e) {
      console.log("marker init: ", e);
    },
    clickMarker() {
      alert("点击了标号");
    },
  },
};
</script>


<style lang="scss">
@import "../../assets/bigScreen/scss/index.scss";
</style>